<template>
  <div class="mobile-page">
    <router-view/>
    <div class="m-page-feature">
      <div class="m-page-label feature-label">
        <span>系统功能</span>
      </div>
      <div class="m-feature-group">
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-01.png"/>
            <div class="m-feature-group-item-desc">用户权限管理</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-02.png"/>
            <div class="m-feature-group-item-desc">实时监控</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-03.png"/>
            <div class="m-feature-group-item-desc">多协议适配</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-04.png"/>
            <div class="m-feature-group-item-desc">硬件连接加密</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-05.png"/>
            <div class="m-feature-group-item-desc">统计报表</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-06.png"/>
            <div class="m-feature-group-item-desc group-item-desc-br">多途径<br/>报警通知</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-07.png"/>
            <div class="m-feature-group-item-desc">历史数据追溯</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-08.png"/>
            <div class="m-feature-group-item-desc">物联参观系统</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-09.png"/>
            <div class="m-feature-group-item-desc group-item-desc-br">自定义<br/>组态界面</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-10.png"/>
            <div class="m-feature-group-item-desc">视频监控</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-11.png"/>
            <div class="m-feature-group-item-desc">大数据分析</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-12.png"/>
            <div class="m-feature-group-item-desc">智能物联配置</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-13.png"/>
            <div class="m-feature-group-item-desc group-item-desc-br">无缝对接<br/>第三方</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-14.png"/>
            <div class="m-feature-group-item-desc group-item-desc-br">界面二维码<br/>分享</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-15.png"/>
            <div class="m-feature-group-item-desc">自定义标签</div>
          </div>
        </div>
        <div class="m-feature-group-item-wrap left">
          <div class="m-feature-group-item">
            <img src="../../assets/img/case/case-mobile-feature-16.png"/>
            <div class="m-feature-group-item-desc group-item-desc-br">跨系统<br/>数据授权分发</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="m-page-nav">
      <div class="m-page-label feature-label">
        <span>更多案例</span>
      </div>
      <div class="m-page-nav-group">
        <div class="m-nav-item-block left" v-for="(item, index) in navList" :key="index">
          <div class="m-nav-item" :class="currentNavIdx === item.idx && currentNavIdx !== 6 ? 'm-nav-item-active': ''" @click="executeNav(item)">
            <div class="m-nav-item-icon left">
              <img :src="item.activeIcon" v-if="currentNavIdx === item.idx"/>
              <img :src="item.icon" v-else/>
            </div>
            <div class="m-nav-item-label left">{{item.label}}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import '../case/styles/mobile-page.scss'
export default {
  name: 'mobile',
  data () {
    return {
      navList: [
        {
          idx: 1,
          url: 'gLvJiPage',
          icon: require('../../assets/img/case/case-nav-icon-01.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-01.png'),
          label: '智能水过滤机'
        },
        {
          idx: 2,
          url: 'kYaJiPage',
          icon: require('../../assets/img/case/case-nav-icon-05.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-05.png'),
          label: '空压机设备'
        },
        {
          idx: 3,
          url: 'gLuPage',
          icon: require('../../assets/img/case/case-nav-icon-02.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-02.png'),
          label: '锅炉设备'
        },
        {
          idx: 4,
          url: 'dDuPage',
          icon: require('../../assets/img/case/case-nav-icon-06.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-06.png'),
          label: '电镀工厂'
        },
        {
          idx: 5,
          url: 'zLiuJiPage',
          icon: require('../../assets/img/case/case-nav-icon-03.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-03.png'),
          label: '整流机设备'
        },
        {
          idx: 6,
          url: 'qWeiDingZhiPage',
          icon: require('../../assets/img/case/case-nav-icon-07.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-07.png'),
          label: '大功率电源'
        }
        /*
        {
          idx: 7,
          url: 'zGuiPage',
          icon: require('../../assets/img/case/case-nav-icon-04.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-04.png'),
          label: '蒸柜设备'
        },
        {
          idx: 8,
          url: 'gLvJiPage',
          icon: require('../../assets/img/case/case-nav-icon-08.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-08.png'),
          label: '其它'
        }
        */
      ],
      currentNavIdx: 1
    }
  },
  created () {
    this.$root.isFill = true
    if (!this.$root.mFlag) {
      this.$router.replace({path: '/case'})
    }
  },
  methods: {
    executeNav (nav) {
      if (nav.idx !== 6) {
        this.currentNavIdx = nav.idx
        this.$router.push({path: nav.url})
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/case/mobile.vue